/*! QivoSend | Shopify FULL tracking (non-inline) | v1 */
(function () {
  if (window.__QIVOSEND_SHOPIFY_FULL__) return;
  window.__QIVOSEND_SHOPIFY_FULL__ = true;

  // ===== CONFIG =====
  var BRAND_ID = 1;

  // ===== DEBUG (opcional): localStorage.setItem('qv_debug','1') =====
  function isDebug() {
    try { return localStorage.getItem('qv_debug') === '1'; } catch (e) { return false; }
  }
  function log() { if (!isDebug()) return; try { console.log.apply(console, ['[QivoSend]'].concat([].slice.call(arguments))); } catch(e){} }

  // ===== IDs =====
  function randHex(len) {
    var out = '';
    var chars = 'abcdef0123456789';
    for (var i = 0; i < len; i++) out += chars[Math.floor(Math.random() * chars.length)];
    return out;
  }
  function getTZ() {
    try { return Intl.DateTimeFormat().resolvedOptions().timeZone || null; } catch(e){ return null; }
  }
  function getVid() {
    var k = 'qv_vid';
    try {
      var v = localStorage.getItem(k);
      if (v && v.length >= 16) return v;
      v = randHex(32);
      localStorage.setItem(k, v);
      return v;
    } catch(e){
      // fallback cookie
      var m = document.cookie.match(/(?:^|;\s*)qv_vid=([^;]+)/);
      if (m) return decodeURIComponent(m[1]);
      var vv = randHex(32);
      document.cookie = 'qv_vid=' + encodeURIComponent(vv) + '; path=/; max-age=' + (60*60*24*365) + '; samesite=lax';
      return vv;
    }
  }
  function getSid() {
    // session de 30 min
    var k = 'qv_sid';
    var now = Date.now();
    try {
      var raw = sessionStorage.getItem(k);
      if (raw) {
        var obj = JSON.parse(raw);
        if (obj && obj.id && obj.exp && now < obj.exp) return obj.id;
      }
      var id = randHex(16);
      sessionStorage.setItem(k, JSON.stringify({ id: id, exp: now + 30*60*1000 }));
      return id;
    } catch(e){
      return randHex(16);
    }
  }

  var VID = getVid();
  var SID = getSid();

  // ===== Base URL (deduce from t.js) =====
  function detectBase() {
    try {
      var s = document.querySelector('script[src*="qivosend.qivodigital.com/t.js"]');
      if (s && s.src) return (new URL(s.src)).origin;
    } catch(e){}
    return 'https://qivosend.qivodigital.com';
  }
  var BASE = detectBase();
  var TRACK_URL = BASE + '/api.php?r=track';
  var IDENTIFY_URL = BASE + '/api.php?r=identify';

  function commonPayload() {
    var u;
    try { u = new URL(location.href); } catch(e){ u = null; }
    var utm = {};
    if (u) {
      ['utm_source','utm_medium','utm_campaign','utm_term','utm_content'].forEach(function(k){
        var v = u.searchParams.get(k);
        if (v) utm[k] = v;
      });
    }
    return {
      brand: BRAND_ID,
      visitor_id: VID,
      session_id: SID,
      ts: Date.now(),
      url: location.href,
      referrer: document.referrer || '',
      device: {
        ua: navigator.userAgent,
        lang: navigator.language || null,
        tz: getTZ(),
        scr: (window.screen ? (screen.width + 'x' + screen.height) : null),
        dpr: window.devicePixelRatio || 1
      },
      utm_source: utm.utm_source || '',
      utm_medium: utm.utm_medium || '',
      utm_campaign: utm.utm_campaign || '',
      utm_term: utm.utm_term || '',
      utm_content: utm.utm_content || ''
    };
  }

  function postJSON(url, payload, keepalive) {
    try {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        mode: 'cors',
        keepalive: !!keepalive
      }).catch(function(){});
    } catch(e) {}
  }

  function track(type, props, keepalive) {
    var p = commonPayload();
    p.type = type;
    p.props = props || {};
    // si existe QivoSend global, igual enviamos directo (cero dependencia)
    log('track', type, p.props);
    return postJSON(TRACK_URL, p, keepalive);
  }

  // ===== Identify (si está logueado) =====
  function identify() {
    try {
      var c = window.QV_CUSTOMER || null;
      var email = c && c.email ? String(c.email).trim() : '';
      if (!email) return;
      var p = { brand: BRAND_ID, visitor_id: VID, email: email, ts: Date.now() };
      log('identify', email);
      postJSON(IDENTIFY_URL, p, false);
    } catch(e){}
  }

  // ===== Cart helpers =====
  function cartRoot() {
    try {
      if (window.Shopify && Shopify.routes && typeof Shopify.routes.root === 'string') return Shopify.routes.root;
    } catch(e){}
    return '/';
  }
  function joinRoot(path) {
    var root = cartRoot();
    if (!root.endsWith('/')) root += '/';
    if (path.startsWith('/')) path = path.slice(1);
    return root + path;
  }
  function fetchCart() {
    return fetch(joinRoot('cart.js'), { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .catch(function(){ return null; });
  }
  function cartSignature(cart) {
    try {
      if (!cart || !cart.items || !Array.isArray(cart.items)) return '';
      var parts = cart.items.map(function(it){
        var vid = it.variant_id || it.id || '';
        var q = it.quantity || 0;
        return String(vid) + ':' + String(q);
      }).sort();
      return parts.join('|');
    } catch(e){ return ''; }
  }

  var lastCartSig = null;
  var lastCartMap = {}; // variant_id -> qty

  function buildCartMap(cart) {
    var m = {};
    try {
      (cart.items || []).forEach(function(it){
        var vid = it.variant_id || it.id;
        if (!vid) return;
        m[String(vid)] = (it.quantity || 0);
      });
    } catch(e){}
    return m;
  }

  function diffMaps(prev, next) {
    var d = { added: [], removed: [], changed: [] };
    var seen = {};
    Object.keys(prev || {}).forEach(function(k){ seen[k]=true; });
    Object.keys(next || {}).forEach(function(k){ seen[k]=true; });

    Object.keys(seen).forEach(function(k){
      var a = prev[k] || 0;
      var b = next[k] || 0;
      if (a === 0 && b > 0) d.added.push({ variant_id: k, from: a, to: b, delta: b-a });
      else if (a > 0 && b === 0) d.removed.push({ variant_id: k, from: a, to: b, delta: b-a });
      else if (a !== b) d.changed.push({ variant_id: k, from: a, to: b, delta: b-a });
    });
    return d;
  }

  function snapshotCart(source, extra) {
    return fetchCart().then(function(cart){
      if (!cart) return;
      var sig = cartSignature(cart);
      var map = buildCartMap(cart);
      var delta = diffMaps(lastCartMap, map);

      lastCartSig = sig;
      lastCartMap = map;

      // Mandamos TODO el cart.js tal cual (y summary aparte)
      var props = {
        kind: 'cart_snapshot',
        source: source || 'unknown',
        delta: delta,
        cart_summary: {
          token: cart.token || null,
          note: cart.note || null,
          currency: cart.currency || 'COP',
          item_count: cart.item_count,
          total_price: cart.total_price,
          items_subtotal_price: cart.items_subtotal_price,
          total_discount: cart.total_discount,
          original_total_price: cart.original_total_price
        },
        cart: cart
      };
      if (extra) props.extra = extra;

      // IMPORTANTE: lo mandamos como add_to_cart para que tu RT lo procese SIEMPRE
      return track('add_to_cart', props, false);
    });
  }

  function isCartMutationUrl(u) {
    if (!u) return false;
    try { u = String(u); } catch(e){ return false; }
    // soporta root con /es/ etc y query strings
    return (
      u.indexOf('/cart/add') !== -1 ||
      u.indexOf('/cart/change') !== -1 ||
      u.indexOf('/cart/update') !== -1 ||
      u.indexOf('/cart/clear') !== -1
    );
  }

  // ===== Intercept fetch =====
  try {
    if (typeof window.fetch === 'function') {
      var _fetch = window.fetch;
      window.fetch = function(input, init) {
        var url = '';
        try { url = (typeof input === 'string') ? input : (input && input.url ? input.url : ''); } catch(e){}
        var isMut = isCartMutationUrl(url);
        var p = _fetch.apply(this, arguments);
        if (isMut) {
          p.then(function(){
            setTimeout(function(){ snapshotCart('fetch:'+url); }, 350);
          }).catch(function(){});
        }
        return p;
      };
    }
  } catch(e){}

  // ===== Intercept XHR =====
  try {
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method, url) {
      this.__qv_url = url;
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function(body) {
      var url = this.__qv_url || '';
      var isMut = isCartMutationUrl(url);
      if (isMut) {
        this.addEventListener('loadend', function(){
          setTimeout(function(){ snapshotCart('xhr:'+url); }, 350);
        });
      }
      return _send.apply(this, arguments);
    };
  } catch(e){}

  // ===== Page & basic events =====
  track('page_view', {
    title: document.title,
    path: location.pathname,
    search: location.search,
    hash: location.hash
  }, false);

  // si está en /cart, marcamos cart_viewed
  try {
    if (location.pathname && location.pathname.indexOf('/cart') !== -1) {
      track('cart_viewed', { source: 'path' }, false);
      snapshotCart('cart_page_load');
    }
  } catch(e){}

  // search_submitted (fallback)
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var q = form.querySelector('input[name="q"], input[type="search"]');
    if (!q || !q.value) return;
    track('search_submitted', { query: q.value, action: form.action || '', method: (form.method||'GET').toUpperCase() }, false);
  }, true);

  // checkout_started (cuando clickea link a /checkout)
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!a || !a.href) return;
    try {
      var href = a.href;
      if (href.indexOf('/checkout') !== -1) {
        track('checkout_started', { source: 'link_click', href: href }, true);
      }
    } catch(err){}
  }, true);

  // ===== Shopify Customer Events (si están disponibles) =====
  function subscribeCustomerEvents() {
    var a = null;
    try {
      if (window.analytics && typeof window.analytics.subscribe === 'function') a = window.analytics;
      else if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.subscribe === 'function') a = Shopify.analytics;
    } catch(e){}
    if (!a) return;

    var evs = [
      'page_viewed',
      'product_viewed',
      'collection_viewed',
      'search_submitted',
      'cart_viewed',
      'product_added_to_cart',
      'product_removed_from_cart',
      'checkout_started',
      'checkout_completed',
      'payment_info_submitted',
      'checkout_contact_info_submitted',
      'checkout_address_info_submitted',
      'checkout_shipping_info_submitted'
    ];

    evs.forEach(function(name){
      try {
        a.subscribe(name, function(evt){
          track(name, { source: 'customer_events', event: evt }, false);
          if (name === 'product_added_to_cart' || name === 'product_removed_from_cart' || name === 'cart_viewed') {
            snapshotCart('customer_events:'+name);
          }
        });
      } catch(e){}
    });
  }
  subscribeCustomerEvents();

  // snapshot inicial (por si ya tenía carrito)
  setTimeout(function(){ snapshotCart('page_load'); }, 1500);

  // identify si hay customer
  identify();

  // flush en salida
  window.addEventListener('pagehide', function(){
    track('page_hide', { path: location.pathname }, true);
  }, { capture: true });

  // expone helpers
  window.QivoSendShopify = {
    vid: VID,
    sid: SID,
    track: track,
    snapshotCart: snapshotCart
  };

})();
